import { s } from '@fullcalendar/core/internal-common'
import jsPDF from 'jspdf'
// eslint-disable-next-line import/no-named-as-default
import autoTable from 'jspdf-autotable'
import { clientHelpers } from '~/client/helperCnel.lib'

/**
 *
 * @param data input type string es: 2023-12-31T00:00:00
 * retunr string es: 31/12/2023
 */
/* export const formatDataIT = (data: string) => {
	// use strong typing and safe guards to ensure that the input is a string
	if (typeof data !== 'string') { return data }
	// remove start T and end string
	data = data.replace('T', '').substr(0, 10)

	// split the string into an array of strings
	const parts = data.split('-')
	// check that the array has three items
	if (parts.length !== 3) { return data }
	// check that the array items are all numbers
	// if (parts.some(part => isNaN(Number(part)))) { return data }
	// return the formatted date
	return `${parts[2]}/${parts[1]}/${parts[0]}`
} */
// Nuova versione con Date del 23/01/2024
export const formatDataIT = (data: string | Date) => {
	let dateString: string

	// Check if data is a Date object
	if (data instanceof Date) {
		// Convert Date to ISO string and take the date part
		// dateString = data.toISOString().substring(0, 10)
		// Format Date to YYYY-MM-DD string
		const year = data.getFullYear()
		const month = String(data.getMonth() + 1).padStart(2, '0') // Months are 0-based in JavaScript
		const day = String(data.getDate()).padStart(2, '0')
		dateString = `${year}-${month}-${day}`
	} else if (typeof data === 'string') {
		// If data is a string, remove 'T' and take the first 10 characters
		dateString = data.replace('T', '').substring(0, 10)
	} else {
		// If data is neither a string nor a Date, return it as is
		return data
	}

	// Split the string into an array of strings
	const parts = dateString.split('-')
	// Check that the array has three items
	if (parts.length !== 3) { return data }
	// Check that the array items are all numbers
	if (parts.some(part => isNaN(Number(part)))) { return data }
	// Return the formatted date
	return `${parts[2]}/${parts[1]}/${parts[0]}`
}

/**
 * @param data input type Date
 * retunr string es: YYYY-MM-DD
 */
export const formatDateYYYYMMDD = (data: Date) => {
	return `${data.getFullYear()}-${data.getMonth() + 1}-${data.getDate()}`
}

/**
 * Consente di ottenere un array di oggetti con le proprietà di tutti gli elementi
 * @param list array di oggetti
 */
export const getKeyFormAnyArraybj = (list: any[]) => {
	// la lista di oggetti può essere che un elemento ha 2 proprietà e un altro 3, quindi devo prendere i nomi delle proprietà di tutti gli elementi
	const keys = list.reduce((acc, item) => {
		return [...acc, ...Object.keys(item)]
	}, [] as string[])
	return [...new Set(keys)] as string[]
}
export const CapitalizeAll = (textVal: string) => {
	// ritornerà il nome del feedType formattato: finaziamenti-e-agevolazioni => Finanziamenti e Agevolazioni
	// attenziane la lettere di congiunzione non sono mai maiuscole
	return textVal.split('-').map(item => item.length > 2 ? item.charAt(0).toUpperCase() + item.slice(1) : item).join(' ')

	// return catRss.split('-').map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ')
}
export const elaboratePathIcon = (nameImage:string, open = false) => {
	const imgname = nameImage.replaceAll(' - ', '_').replaceAll(' ', '_').toLowerCase()
	const nameImageOpen = open ? `${imgname}_icona_bianca` : `${imgname}_icona_blu`
	return `/images/CCNL_icone/settori/${nameImageOpen}.png`
	// return open ? `/images/CCNL_icone/settori/${imgname}_Icona_nera.png` : `/images/CCNL_icone/${imgname}_Icona_bianca.png`
}
export const elaboratePathIconMenu = (nameImage:string) => {
	const imgname = nameImage.replaceAll(' - ', '_').replaceAll(' ', '_').toLowerCase()
	return `/images/CCNL_icone/settori/${imgname}_icona_bianca.png`
}
export const clickListMenuCategory = ref(0)

/**
 * Converts a generic data table to a PDF document.
 *
 * @param title - The title of the PDF document.
 * @param anotherIntro - An array of additional introductory text lines.
 * @param headers - An array of table headers.
 * @param data - An array of objects representing the table data.
 */
/**
 * Converts a generic data table to a PDF document.
 *
 * @param title - The title of the PDF document.
 * @param anotherIntro - An array of additional introductory text lines.
 * @param headers - An array of table headers.
 * @param data - An array of objects representing the table data.
 */
// Type per dati CCNL badge informativi
interface CcnlBadgeInfo {
	settore?: string
	codiceCNEL?: string
	codiceINPS?: string
	dataStipula?: string
	dataDecorrenza?: string
	dataScadenza?: string
}

export const genericDataTableToPdf = async (options: {
	title: string,
	anotherIntro: string[],
	headers: string[],
	data: {[key: string]: any}[],
	ccnlInfo?: CcnlBadgeInfo // Opzionale: dati badge stile ccnlDett.vue
}) => {
	// Crea un nuovo documento PDF in formato landscape e dimensione A4
	// eslint-disable-next-line new-cap
	const doc = new jsPDF('landscape', 'mm', 'a4')

	// Colori base v4.0
	const colorBase = '#111827' // Text-primary v4.0 (era #000000)
	const colorTitle = '#114449' // Primary-dark v4.0 (era #1769aa)
	const colorHeaderBg = '#3d6063' // Primary-700
	const colorHeaderText = '#ffffff'
	const colorStripedRow = '#f9fafb'
	const colorBorder = '#e5e7eb'

	// Badge-dot colors (ccnlDett.vue palette)
	const colorTeal = '#14b8a6' // Settore/Categoria
	const colorPrimary = '#114449' // Codice CNEL
	const colorBlue = '#3b82f6' // Codice INPS
	const colorPurple = '#a855f7' // Data Stipula
	const colorGreen = '#22c55e' // Data Decorrenza
	const colorOrange = '#f97316' // Data Scadenza
	const colorAmount = '#22c55e' // Importi/Euro (green)

	// Badge background (teal delicato)
	const colorBadgeBg = [240, 253, 250] // RGB: #f0fdfа (teal-50)

	const fonSizeTitle = 20
	const pageWidth = doc.internal.pageSize.getWidth()
	const pageHeight = doc.internal.pageSize.getHeight()

	// Logo "Guida Pratica Lavoro" in alto a sinistra
	doc.setFontSize(12)
	doc.setTextColor('#6b7280') // Text-secondary
	doc.setFont('helvetica', 'normal')
	doc.text('Guida Pratica Lavoro', 15, 10)

	// Suddividi il titolo in più righe se supera la larghezza della pagina
	const splitText = doc.splitTextToSize(options.title, pageWidth - 30)
	splitText.forEach((item: string, i: number) => {
		doc.setFontSize(fonSizeTitle)
		doc.setTextColor(colorTitle)
		doc.setFont('helvetica', 'bold')
		if (i === 0) {
			doc.text(item, 15, 18, { align: 'left', maxWidth: pageWidth - 30 })
		} else {
			doc.text(item, 15, 18 + i * 8, { align: 'left' })
		}
	})

	const marginTop = splitText.length * 8 + 21
	let currentY = marginTop

	// 1. RENDERING BADGE INFORMATIVI CCNL (PRIMA - Settore, Codici, Date)
	if (options.ccnlInfo) {
		const badgeStartY = currentY + 5
		const badgeHeight = 12 // Aumentato per più spazio
		const badgeMargin = 3
		const dotSize = 3 // Dot più grande e visibile
		const leftMargin = 15
		const fullWidth = pageWidth - 30

		// Array di badge da renderizzare con layout specifico
		const badges: Array<{label: string, value: string, color: string, x: number, y: number, width: number, isFullWidth?: boolean}> = []

		let currentRowY = badgeStartY

		// Riga 1: Settore (FULL-WIDTH per evitare troncamento)
		if (options.ccnlInfo.settore) {
			badges.push({
				label: 'SETTORE',
				value: options.ccnlInfo.settore,
				color: colorTeal,
				x: leftMargin,
				y: currentRowY,
				width: fullWidth,
				isFullWidth: true
			})
			currentRowY += badgeHeight + badgeMargin
		}

		// Riga 2: CNEL + INPS (2 colonne equal-width)
		const row2Badges: Array<{label: string, value: string, color: string}> = []
		if (options.ccnlInfo.codiceCNEL) {
			row2Badges.push({ label: 'CODICE CNEL', value: options.ccnlInfo.codiceCNEL, color: colorPrimary })
		}
		if (options.ccnlInfo.codiceINPS) {
			row2Badges.push({ label: 'CODICE INPS', value: options.ccnlInfo.codiceINPS, color: colorBlue })
		}

		if (row2Badges.length > 0) {
			const colWidth = (fullWidth - badgeMargin * (row2Badges.length - 1)) / row2Badges.length
			row2Badges.forEach((badge, idx) => {
				badges.push({
					label: badge.label,
					value: badge.value,
					color: badge.color,
					x: leftMargin + idx * (colWidth + badgeMargin),
					y: currentRowY,
					width: colWidth
				})
			})
			currentRowY += badgeHeight + badgeMargin
		}

		// Riga 3: Date (3 colonne equal-width)
		const row3Badges: Array<{label: string, value: string, color: string}> = []
		if (options.ccnlInfo.dataStipula) {
			const dataStipulaFormatted = formatDataIT(options.ccnlInfo.dataStipula)
			row3Badges.push({ label: 'DATA STIPULA', value: String(dataStipulaFormatted), color: colorPurple })
		}
		if (options.ccnlInfo.dataDecorrenza) {
			const dataDecorrenzaFormatted = formatDataIT(options.ccnlInfo.dataDecorrenza)
			row3Badges.push({ label: 'DATA DECORRENZA', value: String(dataDecorrenzaFormatted), color: colorGreen })
		}
		if (options.ccnlInfo.dataScadenza) {
			const dataScadenzaFormatted = formatDataIT(options.ccnlInfo.dataScadenza)
			row3Badges.push({ label: 'DATA SCADENZA', value: String(dataScadenzaFormatted), color: colorOrange })
		}

		if (row3Badges.length > 0) {
			const colWidth = (fullWidth - badgeMargin * (row3Badges.length - 1)) / row3Badges.length
			row3Badges.forEach((badge, idx) => {
				badges.push({
					label: badge.label,
					value: badge.value,
					color: badge.color,
					x: leftMargin + idx * (colWidth + badgeMargin),
					y: currentRowY,
					width: colWidth
				})
			})
			currentRowY += badgeHeight + badgeMargin
		}

		// Renderizza ogni badge con stile migliorato
		badges.forEach((badge) => {
			// Background teal più visibile con bordo colorato
			doc.setFillColor(colorBadgeBg[0], colorBadgeBg[1], colorBadgeBg[2])
			doc.setDrawColor(badge.color) // Bordo del colore del badge!
			doc.setLineWidth(0.5) // Bordo più spesso
			doc.roundedRect(badge.x, badge.y, badge.width, badgeHeight, 1.5, 1.5, 'FD')

			// Dot colorato più grande e visibile
			doc.setFillColor(badge.color)
			doc.circle(badge.x + 3.5, badge.y + badgeHeight / 2, dotSize / 2, 'F')

			// Label (uppercase, grigio secondario)
			doc.setFontSize(7.5)
			doc.setTextColor('#6b7280')
			doc.setFont('helvetica', 'bold')
			doc.text(badge.label, badge.x + 7, badge.y + 4)

			// Value (bold, nero con ellipsis intelligente)
			doc.setFontSize(9)
			doc.setTextColor(colorBase)
			doc.setFont('helvetica', 'bold')

			// Calcola lunghezza massima testo per evitare overflow
			const maxTextWidth = badge.width - 9 // Spazio per dot + padding
			let displayValue = badge.value

			// Truncate solo se necessario (con ellipsis)
			if (badge.isFullWidth && displayValue.length > 60) {
				displayValue = displayValue.substring(0, 60) + '...'
			} else if (!badge.isFullWidth && displayValue.length > 25) {
				displayValue = displayValue.substring(0, 25) + '...'
			}

			doc.text(displayValue, badge.x + 7, badge.y + 8.5, { maxWidth: maxTextWidth })
		})

		// Aggiorna currentY dopo i badge
		currentY = currentRowY + 2
	}

	// 2. RENDERING SOTTOTITOLI (DOPO - Divisori, Valenza)
	if (options.anotherIntro && options.anotherIntro.length > 0) {
		const subBadgeHeight = 10
		const subBadgeMargin = 2.5
		const leftMargin = 15
		const fullWidth = pageWidth - 30

		options.anotherIntro.forEach((item, i) => {
			const badgeY = currentY + i * (subBadgeHeight + subBadgeMargin)

			// Rileva label e valore (split su ":" o "dal")
			let label = ''
			let value = item

			// Pattern 1: "Divisori: F07 Lapidei..."
			if (item.includes(':')) {
				const parts = item.split(':')
				label = parts[0].trim()
				value = parts.slice(1).join(':').trim()
			}
			// Pattern 2: "in vigore dal 24/11/2022"
			else if (item.toLowerCase().includes('in vigore dal')) {
				label = 'in vigore dal'
				value = item.replace(/in vigore dal/i, '').trim()
			}

			// Background grigio-azzurro delicato
			doc.setFillColor(248, 250, 252) // slate-50
			doc.setDrawColor(colorPrimary) // Bordo primary
			doc.setLineWidth(0.4)
			doc.roundedRect(leftMargin, badgeY, fullWidth, subBadgeHeight, 1, 1, 'FD')

			// Label in grassetto con colore primary
			if (label) {
				doc.setFontSize(8.5)
				doc.setTextColor(colorPrimary)
				doc.setFont('helvetica', 'bold')
				doc.text(label + ':', leftMargin + 3, badgeY + 6.5)

				// Calcola larghezza label per posizionare il valore
				const labelWidth = doc.getTextWidth(label + ': ')

				// Valore in nero normale
				doc.setTextColor(colorBase)
				doc.setFont('helvetica', 'normal')
				const maxValueWidth = fullWidth - labelWidth - 6
				doc.text(value, leftMargin + 3 + labelWidth, badgeY + 6.5, { maxWidth: maxValueWidth })
			} else {
				// Se non c'è label, renderizza tutto il testo normale
				doc.setFontSize(8.5)
				doc.setTextColor(colorBase)
				doc.setFont('helvetica', 'normal')
				doc.text(item, leftMargin + 3, badgeY + 6.5, { maxWidth: fullWidth - 6 })
			}
		})

		currentY += options.anotherIntro.length * (subBadgeHeight + subBadgeMargin) + 3
	}

	// Prepara i dati per la tabella
	const tableNew = options.data.map((row) => {
		const rowValues = Object.values(row) as string[]
		return rowValues
	})

	// Carica logo per footer (una volta)
	const img = new Image()
	img.src = '/images/home_icone/R_background_stampa_new.png'
	await img.decode()
	const canvas = document.createElement('canvas')
	canvas.width = img.width
	canvas.height = img.height
	const context = canvas.getContext('2d')
	context?.drawImage(img, 0, 0, img.width, img.height)
	const imageData = canvas.toDataURL('image/png')
	const aspectRatio = img.width / img.height
	const logoWidth = 40
	const logoHeight = logoWidth / aspectRatio

	// Configurazione tabella avanzata
	autoTable(doc, {
		head: [options.headers],
		body: tableNew,
		startY: currentY,
		margin: { left: 15, right: 15, top: 15, bottom: 20 },

		// Stili moderni v4.0
		styles: {
			fontSize: 9,
			cellPadding: 3,
			lineColor: colorBorder,
			lineWidth: 0.1,
			font: 'helvetica'
		},

		// Header styling
		headStyles: {
			fillColor: colorHeaderBg,
			textColor: colorHeaderText,
			fontStyle: 'bold',
			fontSize: 9,
			halign: 'center',
			valign: 'middle',
			lineColor: colorBorder,
			lineWidth: 0.2
		},

		// Body styling
		bodyStyles: {
			textColor: colorBase,
			fontSize: 9,
			halign: 'center',
			valign: 'middle'
		},

		// Righe alternate (striped)
		alternateRowStyles: {
			fillColor: colorStripedRow
		},

		// Auto-allineamento colonne numeriche
		columnStyles: options.headers.reduce((acc, header, index) => {
			const lowerHeader = header.toLowerCase()

			// Color coding badge-dot style (ccnlDett.vue palette)
			// SETTORE/CATEGORIA → Teal
			if (lowerHeader.match(/settore|categoria|sezione/i)) {
				acc[index] = {
					halign: 'left',
					cellPadding: { left: 4, right: 2 },
					textColor: colorTeal,
					fontStyle: 'bold'
				}
			}
			// CODICE CNEL → Primary
			else if (lowerHeader.match(/cnel|h05k|codice.*cnel/i)) {
				acc[index] = {
					halign: 'center',
					textColor: colorPrimary,
					fontStyle: 'bold'
				}
			}
			// CODICE INPS → Blue
			else if (lowerHeader.match(/inps|codice.*inps/i)) {
				acc[index] = {
					halign: 'center',
					textColor: colorBlue,
					fontStyle: 'bold'
				}
			}
			// DATA STIPULA → Purple
			else if (lowerHeader.match(/stipula|inizio|sottoscrizione/i)) {
				acc[index] = {
					halign: 'center',
					textColor: colorPurple
				}
			}
			// DATA DECORRENZA → Green
			else if (lowerHeader.match(/decorrenza|vigore|dal/i)) {
				acc[index] = {
					halign: 'center',
					textColor: colorGreen
				}
			}
			// DATA SCADENZA → Orange
			else if (lowerHeader.match(/scadenza|termine|al\b|fine/i)) {
				acc[index] = {
					halign: 'center',
					textColor: colorOrange
				}
			}
			// IMPORTI/EURO → Green (amount)
			else if (lowerHeader.match(/€|euro|importo|retribuzione|minimo|massimo|%|percentuale/i)) {
				acc[index] = {
					halign: 'right',
					textColor: colorAmount,
					fontStyle: 'bold'
				}
			}
			// ALTRE DATE → Center default
			else if (lowerHeader.match(/data|periodo|valenza/i)) {
				acc[index] = { halign: 'center' }
			}
			// DESCRIZIONI/TESTO → Left default
			else if (lowerHeader.match(/descrizione|nome|qualifica|livello|tipo/i)) {
				acc[index] = { halign: 'left', cellPadding: { left: 4, right: 2 } }
			}

			return acc
		}, {} as any),

		// Footer con paginazione e logo
		didDrawPage: (data: any) => {
			// Footer con numero pagina
			doc.setFontSize(8)
			doc.setTextColor('#6b7280')
			doc.setFont('helvetica', 'normal')

			const pageNum = `Pagina ${data.pageNumber}`
			const dataStampa = `Stampato il ${formatDataIT(new Date().toISOString())}`

			// Numero pagina (sinistra)
			doc.text(pageNum, 15, pageHeight - 10)

			// Data stampa (centro)
			doc.text(dataStampa, pageWidth / 2, pageHeight - 10, { align: 'center' })

			// Logo (destra)
			doc.addImage(
				imageData,
				'PNG',
				pageWidth - logoWidth - 15,
				pageHeight - logoHeight - 8,
				logoWidth,
				logoHeight
			)
		},

		// Tema moderno
		theme: 'grid',

		// Row hover effect simulato con bordi
		showHead: 'firstPage',

		// Gestione overflow
		tableWidth: 'auto'
	})

	// Auto-print quando aperto
	doc.autoPrint()

	// Nome file sicuro
	let lengthTitle = 150
	if (options.title.length > lengthTitle) {
		const indexSpaceAfter = options.title.substring(0, lengthTitle).lastIndexOf(' ')
		lengthTitle = indexSpaceAfter === -1 ? 50 : indexSpaceAfter
	}
	let titleTruncate = options.title.length > 20 ? options.title.substring(0, lengthTitle) : options.title
	titleTruncate = safeCharForNameFile(titleTruncate)

	// Salva PDF
	doc.save(`${titleTruncate}.pdf`)
}
/**
 * Crea nome del file sostituendo tutti i caratteri non ammessi dal sistema operativo
 * sostituisce i caratteri non ammessi con un underscore
 * @param title
 */
const safeCharForNameFile = (title: string) => {
	// Genera un nome casuale per il file
	const randomNameString = Math.random().toString(36).substring(7)
	// Sostituisci i caratteri non ammessi con un underscore
	return `${title.replace(/[/\\?%*|"<>:]/g, '_').replace(/\s/g, '')}_${randomNameString}`
}

/**
 * Funzione che dato un array di oggetti, elabora la proprietà string specificata, ed trasforma la stringa in CamelCase evitando di trasformare in maiuscolo le lettere di congiunzione
 */
export const capitalizeAll = <T>(list: T[], props: (keyof T)[]) => {
	// Definisci un array di parole di congiunzione
	const conjunctions = ['non', 'per', 'e', 'o', 'ma', 'se', 'delle', 'del', 'degli', 'dei', 'della', 'dello', 'alla', 'alle', 'agli', 'allo', 'dall', 'dalle', 'dagli', 'dallo', 'nell', 'nelle', 'negli', 'nello', 'sull', 'sulle', 'sugli', 'sullo']
	const upperParola = ['cisal', 'confsal', 'cgil', 'cisl', 'uil', 'pmi', 'conflavoro', 'dmo', 'confesercenti', 'confcommercio', 'confapi', 'confartigianato', 'confassociazioni', 'confassociazionilavoratori', 'confassociazionidatorialavoratori']
	const copyArray = [...list]
	try {
		// Esegui un ciclo su ogni oggetto nell'array
		list.forEach((item) => {
			// Esegui un ciclo su ogni proprietà nell'array di proprietà
			props.forEach((prop) => {
				// Recupera il valore della proprietà specificata
				const value = item[prop] as string

				// Dividi la stringa in due parti basate sulle parentesi
				const [beforeParenthesis, insideParenthesis] = value.split(/(\(.*?\))/)

				// Gestisci la parte prima delle parentesi
				const beforeWords = beforeParenthesis.toLowerCase().split(' ')
				const capitalizedBefore = beforeWords.map((item, index) => {
					// Applica la logica di capitalizzazione come prima
					if (item.includes('.')) {
						return item.toUpperCase()
					} else if (conjunctions.includes(item)) {
						return item
					} else if (upperParola.includes(item)) {
						return item.toUpperCase()
					} else if (index === 0 || (index > 0 && beforeWords[index - 1].endsWith(')'))) {
						return item.charAt(0).toUpperCase() + item.slice(1)
					} else {
						return item.length > 2 ? item.charAt(0).toUpperCase() + item.slice(1) : item
					}
				}).join(' ')

				// Se esiste una parte con parentesi, gestiscila
				let capitalizedInside = ''
				if (insideParenthesis) {
					const insideWords = insideParenthesis.slice(1, -1).split('-') // .toLowerCase()
					capitalizedInside = '(' + insideWords.map((item, index) => {
						// Applica la logica di capitalizzazione come prima
						// per ora non modifico le parole con la parentesi
						return item
					}).join('-') + ')'
				}

				// Unisci le due parti
				item[prop] = capitalizedBefore + (capitalizedInside ? ' ' + capitalizedInside : '')
			})
		})

		// Restituisci l'array di oggetti modificato
		return list
	} catch {
		// Se si verifica un errore, restituisci l'array originale
		return copyArray
	}
}

export const capitalizeHeaderComRetrib = (inputData: string) => {
	try {
		const excludeWords = ['III']
		const words = inputData.split(' ')
		const capitalizedWords = words.map((word, index) => {
			if (index === 0 || excludeWords.includes(word)) {
				return word
			}
			return word.charAt(0).toUpperCase() + word.slice(1)
		})
		return capitalizedWords.join(' ')
	} catch (error) {
		return inputData
	}
}

export { clientHelpers }
